import { FC } from "react";
import { components } from "react-select";

import { SelectComponentProps } from "./types";

import { SelectedHiddenCountIndicator } from "./SelectedHiddenCountIndicator";

type IndicatorsContainerProps = SelectComponentProps["IndicatorsContainer"];

export const IndicatorsContainer: FC<IndicatorsContainerProps> = ({
  children,
  ...props
}) => {
  if (!props.isMulti)
    return (
      <components.IndicatorsContainer {...props}>
        {children}
      </components.IndicatorsContainer>
    );

  const showHiddenCount =
    props.selectProps.hiddenPillLabels?.length > 0 &&
    !props.selectProps.menuIsOpen;

  return (
    <components.IndicatorsContainer {...props}>
      <SelectedHiddenCountIndicator
        showPill={showHiddenCount}
        labels={props.selectProps.hiddenPillLabels}
      />
      {children}
    </components.IndicatorsContainer>
  );
};
